import React from "react";
import RatingItem from "./RatingItem";
import FrontSliderBlurb from "./FrontSliderBlurb";
import {contentURL} from "src/utilities/utilityFunctions";

const DancePartyWithFriendsSlide=()=>{
    return (
        <div className="ls-slide" data-ls="slidedelay:7000; transition2d: all;" id="dancePartyWithFriendsSlide">
            <img src={contentURL() + "/site/images/layerslider-gallery-tn/disco-ceiling.png"}
                 className="ls-bg" alt="Slide background"/>

            <img className="ls-l" style={{top:"120px",left:"205px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:300;easingin:easeOutElastic;skewxin:30;skewyin:30;transformoriginin:50% 0% 50%;offsetxout:0;parallaxlevel:1;"
                 src={contentURL() + "/site/images/layerslider-gallery/dance.png"} alt="" />

            <img className="ls-l" style={{top:"185px",left:"205px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:2;delayin:500;rotatexin:90;rotateyin:90;offsetxout:0;parallaxlevel:-1;"
                 src={contentURL() + "/site/images/layerslider-gallery/party.png"} alt=""/>

            <img className="ls-l" style={{top:"252px",left:"125px",whiteSpace: "nowrap"}}
                 data-ls="offsetyin:250;delayin:1300;scalexin:3;scaleyin:3;offsetxout:0;parallaxlevel:-2;"
                 src={contentURL() + "/site/images/layerslider-gallery/with.png"} alt=""/>

            <img className="ls-l" style={{top:"250px",left:"216px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;delayin:1900;rotatexin:90;rotateyin:90;offsetxout:0;parallaxlevel:3;"
                 src={contentURL() + "/site/images/layerslider-gallery/friends.png"} alt=""/>

            <img className="ls-l" style={{top:"365px",left:"243px",whiteSpace: "nowrap"}}
                 data-ls="delayin:2500;parallaxlevel:-2;"
                 src={contentURL() + "/site/images/layerslider-gallery/disco-ball-divider.png"} alt=""/>

            <img className="ls-l" style={{top:"415px",left:"234px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:-100;delayin:3000;offsetxout:0;offsetyout:100;parallaxlevel:3;"
                 src={contentURL() + "/site/images/layerslider-gallery/come-join.png"} alt=""/>

            <img className="ls-l"
                 style={{top:"70px",left:"-300px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:150;delayin:2700;easingin:easeInBack;offsetxout:0;offsetyout:-150;parallaxlevel:5;"
                 src={contentURL() + "/site/images/layerslider-gallery/girl1.png"} alt=""/>

            <img className="ls-l" style={{top:"220px",left:"0px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:150;delayin:2000;easingin:swing;offsetxout:0;offsetyout:-150;parallaxlevel:3;"
                 src={contentURL() + "/site/images/layerslider-gallery/boy1.png"} alt=""/>

            <img className="ls-l"
                 style={{top:"55px",left:"440px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:150;delayin:2300;easingin:easeOutQuart;offsetxout:0;offsetyout:-150;parallaxlevel:3;"
                 src={contentURL() + "/site/images/layerslider-gallery/boy2.png"} alt=""/>

            <img className="ls-l"
                 style={{top:"85px",left:"755px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:150;delayin:2500;offsetxout:0;offsetyout:-150;parallaxlevel:4;"
                 src={contentURL() + "/site/images/layerslider-gallery/boy3.png"} alt=""/>
            <div className="ls-l"
                     style={{top:"105px",left:"1350px"}}
                     data-ls="offsetxin:500;offsetyin:0;delayin:3500;easingin:easeOutQuart;offsetxout:500;offsetyout:0;parallaxlevel:1;"
                >
                <FrontSliderBlurb delay="0" show="true"
                                          blurb={"Virtual Dance Parties with friends and family. Choose one of our 'edu-danceable' lists. Spotify tie in coming soon."}/>
            </div>
            <RatingItem yeatitle={"...I LOVE this!!"}
                        mehtitle={"...I could go for it. Maybe."}
                        naytitle={"...I don't see the point."} bgcolor={"#EEEEEE"}
                        top={450} left={1050}
                        audience={"adult"}
                        feature={"dncepartwf"} label={"As an adult..."} key="sliderImage16"/>,
            <RatingItem yeatitle={"LOVE this!!"}
                        mehtitle={"take It Or Leave It"}
                        naytitle={"not like this."} bgcolor={"#EEEEEE"}
                        top={459} left={1050} audience={"child"}
                        feature={"dncepartwf"}
                        label={"My child will..."}
                        key="sliderImage17"/>,

        </div>
    )
};
/*
            <img className="ls-l" style={{top:"42px",left:"173px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:0;offsetyin:150;delayin:2200;easingin:easeInOutBack;offsetxout:0;offsetyout:-150;parallaxlevel:-4;"
                 src="https://wedesignthemes.com/html/kidslife/images/layerslider-gallery/girl2.png" alt=""/>
 */
export default DancePartyWithFriendsSlide;
